module.exports = __webpack_public_path__ + "img/android.650db94.png";